import React from 'react';
import { DialogContentText as MuiDialogContentText } from '@mui/material';
export const DialogContentText = ({ _sx, className = '', children, dataTestId, }) => (React.createElement(MuiDialogContentText, { sx: _sx, className: className, "data-testid": dataTestId }, children));
